import util from '../utils'
import {Notification } from 'element-ui';


const CityExamMultipleReportLayout = r => require(['@/pages/exam/multiple/report_city/layout'], r)

// 市多科报告
const CityExamMultipleReportAreaLayout = r => require(['@/pages/exam/multiple/report_city/area/layout'], r)
const CityExamMultipleReportAreaBasic = r => require(['@/pages/exam/multiple/report_city/area/basic'], r)
const CityExamMultipleReportAreaLevel = r => require(['@/pages/exam/multiple/report_city/area/level'], r)
const CityExamMultipleReportAreaRank = r => require(['@/pages/exam/multiple/report_city/area/rank'], r)
const CityExamMultipleReportAreaTranscript = r => require(['@/pages/exam/multiple/report_city/area/transcript'], r)

const CityExamMultipleReportSchoolLayout = r => require(['@/pages/exam/multiple/report_city/school/layout'], r)
const CityExamMultipleReportSchoolBasic = r => require(['@/pages/exam/multiple/report_city/school/basic'], r)
const CityExamMultipleReportSchoolLevel = r => require(['@/pages/exam/multiple/report_city/school/level'], r)
const CityExamMultipleReportSchoolRank = r => require(['@/pages/exam/multiple/report_city/school/rank'], r)
const CityExamMultipleReportSchoolTranscript = r => require(['@/pages/exam/multiple/report_city/school/transcript'], r)



function requireAuth(to, from, next) {
  if (!util.isLogin()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (to.meta.auth && !util.isAuth(to.meta.auth)) {
      const info = {
        title: "禁止访问！",
        message: "对不起，您没有本页访问权限",
        type: "error"
      }
      Notification(info);
    } else {
      next()
    }
  }
}
function isNotRequireAuth(to, from, next) {
  next()
}

export default [

  {
    path: '/region/exam/multiple/city/report',
    component: CityExamMultipleReportLayout,
    redirect: '/region/exam/multiple/city/area/report',
    children: [
      // 多科区域报告
      {
        path: '/region/exam/multiple/city/area/report',
        component: CityExamMultipleReportAreaLayout,
        redirect: '/region/exam/multiple/city/area/report/basic/:id',
        children: [
          {
            path: '/region/exam/multiple/city/area/report/basic/:id',
            component: CityExamMultipleReportAreaBasic,
            name: 'Region-area-exam-multiple-basic',
          },
          {
            path: '/region/exam/multiple/city/area/report/level/:id',
            component: CityExamMultipleReportAreaLevel,
            name: 'Region-area-exam-multiple-level',
          },
          {
            path: '/region/exam/multiple/city/area/report/rank/:id',
            component: CityExamMultipleReportAreaRank,
            name: 'Region-area-exam-multiple-rank',
          },
          {
            path: '/region/exam/multiple/city/area/report/transcript/:id',
            component: CityExamMultipleReportAreaTranscript,
            name: 'Region-area-exam-multiple-transcript',
          }
        ]
      },

      // 学校报告
      {
        path: '/region/exam/multiple/city/school/report',
        component: CityExamMultipleReportSchoolLayout,
        redirect: '/region/exam/multiple/city/school/report/basic/:id',
        children: [
          {
            path: '/region/exam/multiple/city/school/report/basic/:id',
            component: CityExamMultipleReportSchoolBasic,
            name: 'Region-school-exam-multiple-basic',
          },
          {
            path: '/region/exam/multiple/city/school/report/level/:id',
            component: CityExamMultipleReportSchoolLevel,
            name: 'Region-school-exam-multiple-level',
          },
          {
            path: '/region/exam/multiple/city/school/report/rank/:id',
            component: CityExamMultipleReportSchoolRank,
            name: 'Region-school-exam-multiple-rank',
          },
          {
            path: '/region/exam/multiple/city/school/report/transcript/:id',
            component: CityExamMultipleReportSchoolTranscript,
            name: 'Region-school-exam-multiple-transcript',
          }
        ]
      }
    ]
  },

]


// WEBPACK FOOTER //
// ./src/router/cityReport.js